import CloudinaryPhoto from '../components/cloudinary/CloudinaryPhoto';

export default function HeaderLogo({ publicId }) {
	return <CloudinaryPhoto
	         cloudName="prodz-com"
	         publicId={publicId}
	         height={85} />
}